import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";

import { empty } from "../../functions";
import { ExternalpageService } from "../../shared/services/externalpage.service";
import { ModalService } from "../../shared/services/modal.service";

@Component({
  selector: "app-admin-externalpages",
  templateUrl: "./admin-externalpages.component.html",
  styleUrls: ["./admin-externalpages.component.scss"],
  standalone: false,
})
export class AdminExternalpagesComponent implements OnInit {
  readonly externalpageService = inject(ExternalpageService);
  readonly router = inject(Router);
  readonly modal = inject(ModalService);

  configTable = {
    reloadListener: new Subject(),
    buttons: <any>[],
  };

  ngOnInit(): void {}

  /**
   * Go to update page of this item
   *
   * @param $data
   */
  updateExternalPage($data: any) {
    this.router.navigateByUrl(
      "/admin/externalpage/" + $data.type + "/" + $data.id
    );
  }

  /**
   * Delete a single external page
   *
   * @param $id
   */
  deleteExternalPage($id: string) {
    this.modal
      .Confirm("Delete", "Are you sure you want to delete this?")
      .then((confirm) => {
        if (confirm === true) {
          this.externalpageService
            .apiDeleteExternalPage($id)
            .subscribe(() => {
              // Trigger reload if available
              if (this.hasOwnProperty("configTable")) {
                if (this.configTable.hasOwnProperty("reloadListener")) {
                  this.configTable.reloadListener.next(true);
                }
              }
            });
        }
      })
      .catch(() => {});
  }

  handleButtonEvent($event: any) {
    if (!empty($event["event"])) {
      switch ($event["event"]) {
        case "edit":
          this.updateExternalPage($event["data"]);
          break;

        case "delete":
          this.deleteExternalPage($event["data"]["id"]);
          break;
      }
    }
  }
}
